import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { HomePageComponent } from './homepage/homepage.component';
import { NavigationbarComponent } from './navigationbar/navigationbar.component';
import { SidebarComponent } from './navigationbar/sidebar/sidebar.component';
import { ROUTE_MODULES } from "./app.routing";
import { ConfigService } from "./config/config.service";
import { LandingpageComponent } from './landingpage/landingpage.component';
import { AboutusComponent } from './landingpage/sections/aboutus/aboutus.component';
import { HeaderMaskComponent } from './header-mask/header-mask.component';
import { MissionComponent } from './landingpage/sections/mission/mission.component';
import { HowItWorksComponent } from './landingpage/sections/how-it-works/how-it-works.component';
import { ContactUsComponent } from './landingpage/sections/contact-us/contact-us.component';
import { SignupComponent } from './signup/signup.component';
import { SigninComponent } from './signin/signin.component';
import { AuthenticationService } from "./shared/auth/authentication.service";
import { OnBoardLocalStoreService } from "./shared/on-board-local-store.service";
import { FooterComponent } from './footer/footer.component';
import { CareersComponent } from './careers/careers.component';
import { HashLocationStrategy } from "@angular/common";
import { JobAdvComponent } from './careers/job-adv/job-adv.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    NavigationbarComponent,
    SidebarComponent,
    LandingpageComponent,
    AboutusComponent,
    HeaderMaskComponent,
    MissionComponent,
    HowItWorksComponent,
    ContactUsComponent,
    SignupComponent,
    SigninComponent,
    FooterComponent,
    CareersComponent,
    JobAdvComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ROUTE_MODULES
  ],
  providers: [
    ConfigService,
    AuthenticationService,
    OnBoardLocalStoreService,
    HashLocationStrategy
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}





// WEBPACK FOOTER //
// ./src/app/app.module.ts